const SearchResult = ({ item }) => {
  const { url, title: titleOriginal, intro } = item.document;
  const { title } = item.highlights;

  return (
    <article className="teaser">
      <a href={url}>
        <div className="teaser__inner">
          <a href={url}>
            <h3
              className="teaser__title"
              dangerouslySetInnerHTML={{ __html: title || titleOriginal }}
            />
          </a>
          {intro && (
            <div
              dangerouslySetInnerHTML={{ __html: intro }}
              className="teaser__description"
            />
          )}
        </div>
      </a>
    </article>
  );
};

export default SearchResult;
